import React from 'react';

import PageLayout from '@/components/layout/PageLayout';
import Table from '@/components/ui/tables/Table';
import { ExportDropdown } from '@/components/ui/filters/ExportDropdown';
import { AttendanceFiltersPanel } from '@/components/features/attendance';
import { useAttendanceMarksAdminPage } from '@/hooks/attendance/management/useAttendanceMarksAdminPage';
import type { SearchFilterConfig } from '@/hooks/attendance/common/useAttendanceSearchFilters';
import type { DimensionalFilterConfig } from '@/hooks/attendance/common/useEmployeeDimensionalFilter';


const SEARCH_CONFIG: SearchFilterConfig = {
  dateRange: true,
  events: true,
  markStatus: true,
};

const DIMENSIONAL_CONFIG: DimensionalFilterConfig = {
  company: true,
  area: true,
  position: true,
  costCenter: true,
  location: true,
  contractModality: true,
  securityGroup: true,
  employeeStatus: true,
  employee: true,
};

export const AttendanceMarksAdmin: React.FC = () => {
  const { marks, filtersPanel } = useAttendanceMarksAdminPage({
    searchConfig: SEARCH_CONFIG,
    dimensionalConfig: DIMENSIONAL_CONFIG,
  });

  return (
    <PageLayout>
      <div className="flex flex-col gap-6" data-testid="attendance-marks-admin-page">
        <AttendanceFiltersPanel
          config={SEARCH_CONFIG}
          state={filtersPanel}
          dimensionalConfig={DIMENSIONAL_CONFIG}
        />

        <div className="flex justify-end">
          <ExportDropdown
            onExport={marks.onExport}
            placement="right"
            isLoading={marks.isExporting}
            disabled={marks.total === 0}
            availableFormats={['EXCEL']}
          />
        </div>

        <Table
          columns={marks.columns}
          data={marks.rows}
          totalRows={marks.total}
          isLoading={marks.isLoading}
          searchable
          onSearch={marks.onSearch}
          serverSideSort
          initialSort={{ key: 'fullName', direction: 'asc' }}
          onSortChange={marks.onSortChange}
          actions={marks.actions}
          pagination={{
            page: marks.page,
            pageSize: marks.pageSize,
            total: marks.total,
            onChange: marks.setPage,
            onPageSizeChange: marks.setPageSize,
          }}
          data-testid="attendance-marks-admin-table"
        />
      </div>
    </PageLayout>
  );
};

export default AttendanceMarksAdmin;
